module.exports = __webpack_public_path__ + "img/kocht_ellwangen-lg.07f9572d.webp";